import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { useLocation } from "react-router-dom";
import { PageLoader } from "../components/loader/Loader";

const PrivateRoute: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <PageLoader />;
  }

  return isAuthenticated ? (
    <div
      className={`page-container flex flex-col justify-between ${
        location.pathname === "/dashboard" ? "mainDashBoardContainer" : ""
      }`}
    >
      <div className="flex-1">
        <Outlet />
      </div>
      <footer className="footer">
        <div className="footer-content">
          <p className="m-b-0">
            Copyright © 2025 Facility Management All rights reserved
          </p>
        </div>
      </footer>
    </div>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
